<template>
  <UploadDirectory
    :label="label"
    :dirname="spriteDirname"
    :disabled="attrDisabled == 'all'"
    :dirname-suffix="'.文件夹'"
    :tooltip="spriteImageInfo"
    @upload="onUploadSprite"
    @delete="onDeleteSprite"
  />
</template>

<script lang="ts" setup>
import { useShapeSprite } from '@/hooks';
import { Shape } from '@/services/shape';
import { useEditorStore } from '@/store/use-editor-store';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { computed } from 'vue';
import { PropType } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  label: {
    type: String,
    default: '上传视频'
  },
  resourceName: {
    type: String as PropType<'images'>,
    required: true
  }
});

const editorStore = useEditorStore();
const watcfaceStore = useWatchfaceStore();
const attrDisabled = computed(() => editorStore.attrDisabled);
const { pickThenUploadSpriteImages } = useShapeSprite();

const colorId = computed(() => {
  const colorId =
    watcfaceStore.colorMode == 'recolor'
      ? editorStore.theme?.colorGroupTable?.[0]?.id
      : editorStore.themeColor?.id;
  return colorId;
});

const spriteImageInfo = computed(() => {
  const device = watcfaceStore.watchfaceDevice;
  if (device?.spriteRules?.size) {
    const { w, h } = device.spriteRules.size;
    return `上传图片尺寸≤${w}*${h}`;
  } else {
    return '';
  }
});

const spriteDirname = computed(() => {
  const imgs = props.shape.getResources({
    resourceName: props.resourceName,
    colorGroup: colorId.value ?? ''
  });
  return imgs[0]?.split('/')?.[0];
});

const onDeleteSprite = () => {
  const shape = props.shape;
  shape.deleteResource({
    resourceName: props.resourceName,
    colorGroup: editorStore.themeColor?.id ?? ''
  });
};

const onUploadSprite = async () => {
  const shape = props.shape;
  pickThenUploadSpriteImages(shape, {
    clear: true,
    resourceName: props.resourceName
  });
};
</script>
